import { createI18n } from 'vue-i18n'
import messages from './messages.json'

// messages 객체 구조 변환
const transformedMessages = {
  ko: {},
  en: {},
  zh: {}
};

// messages의 각 키에 대해 언어별로 재구성
Object.keys(messages).forEach(key => {
  transformedMessages.ko[key] = messages[key].ko;
  transformedMessages.en[key] = messages[key].en;
  transformedMessages.zh[key] = messages[key].zh;
});

const i18n = createI18n({
  legacy: false, // legacy 모드로 변경
  locale: 'zh',
  globalInjection: true, // 전역 주입 활성화
  messages: transformedMessages,
  missing: (locale, key) => {
    console.warn(`Translation key "${key}" not found for locale "${locale}"`)
    return key
  }
})

export default i18n

/**
 * 언어 변경 함수
 *
 * @deprecated FE-D7 patch (SPEC-CHINA-ADMIN-LOCALE-CORE-001 expert-frontend ANALYZE)
 *
 * REQ-LOCALE-FE-008 단일 진입점 원칙에 따라 향후 모든 locale 변경은
 * `store.dispatch('locale/applyLocale', { ... })` 통해서만 수행한다.
 * 본 함수는 안전망(boot 직전 호출 등 store 미가용 상황)으로만 유지되며,
 * Vuex state는 동기화하지 않으므로 store 가용 시점 이후 호출 금지.
 *
 * 현재 호출처 0건 (boot은 main.js가 직접 i18n.global.locale.value/document.lang을 설정).
 * Phase 3 후속 SPEC에서 본 함수를 완전 제거 예정.
 *
 * REQ-LOCALE-FE-001: composition mode (legacy:false) 규약 — .value 로 ref 갱신
 * REQ-LOCALE-FE-011: html lang 동기 갱신 (FE-D7 추가)
 * 동시에 localStorage admin_china_locale 동기 저장 (다음 새로고침 fallback 보장)
 */
export const setLanguage = (lang) => {
  if (transformedMessages[lang]) {
    i18n.global.locale.value = lang
    document.documentElement.lang = lang
    localStorage.setItem('admin_china_locale', lang)
  }
}

// 현재 언어 가져오기 — composition mode ref 규약
export const getCurrentLanguage = () => i18n.global.locale.value